import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router-dom";

import { HvButton } from "@hitachivantara/uikit-react-core";
import { Add } from "@hitachivantara/uikit-react-icons";

import useStyles from "./styles";

const MemberSettingsTableControl: React.FC = () => {
  const { t } = useTranslation("common");
  const history = useHistory();
  const { url } = useRouteMatch();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HvButton
        className={classes.add}
        category="semantic"
        startIcon={<Add />}
        onClick={() => history.push(`${url}/add`)}
      >
        {t("common:buttons.addServiceAccount")}
      </HvButton>
    </div>
  );
};

export default MemberSettingsTableControl;
